import { LoadScript } from '@react-google-maps/api';
import { ReactNode } from 'react';

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export default function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  return (
    <LoadScript googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
      {children}
    </LoadScript>
  );
}